import { isEmpty } from 'lodash'
import { AllClinicsAvailabilitiesGroupedByPeriod, AvailabilitiesPeriod } from '@context/AppointmentCalendarContext/types'

export const getPeriodOffsetByPeriod = (
  currentPeriod: AvailabilitiesPeriod,
  allClinicsAvailabilities?: AllClinicsAvailabilitiesGroupedByPeriod,
  backwards?: boolean
): AvailabilitiesPeriod | undefined => {
  if (isEmpty(currentPeriod) || isEmpty(allClinicsAvailabilities)) return
  const nextPeriod: AvailabilitiesPeriod = {}
  const firstPeriodAvailabilities = Object.values(currentPeriod)[0]?.[0]
  Object.entries(allClinicsAvailabilities).forEach(([clinicId, groupedAvailabilities]) => {
    const indexOfAvailabilityWeek = groupedAvailabilities.findIndex(
      (availabilityWeekFromGroup) => availabilityWeekFromGroup[0].date === firstPeriodAvailabilities?.date
    )

    const offset = backwards ? -1 : 1

    nextPeriod[clinicId] = groupedAvailabilities[indexOfAvailabilityWeek + offset]
  })

  return nextPeriod
}
